export default __webpack_public_path__ + "static/media/HomeGrid1.65f4860f.jpg";